import React from "react";
import { View, Text, Pressable, StyleSheet,Platform } from "react-native";
import { Ionicons, Entypo,FontAwesome5,} from "@expo/vector-icons";
import { WorkflowSteps } from "./WorkflowSteps";
import { getIconItem, getIconItemPTW } from "../utils/itemCommonFunctions";
import { glueStyles } from "../configGlueStack/gluestack-ui.config";
import Spacer from "./base/Spacer"

import {
  Button as Button2, Box,
  ButtonIcon,
} from "@gluestack-ui/themed";
import {
  Button, Icon,
} from "native-base"


export const ItemRow = React.memo(({
    item,
    department,
    form,
    onPress,
    isSwiping,
    currentStateOnly,
    statusStore,
    onLayout,
    navigation,
    fromTaskId,
    showCheck,
    selectItem,
    itemsSelected,
 }: any) => {
    const _hasSteps = ["ptw","workflow"].includes(form.type);
    if(_hasSteps){
        item.stepNumber = item.stepNumber || 0;
    }
    const stepNumber = (item.membersId == null ? -1 : (item.stepNumber ?? 1)) + 1;

    const handleMainPress = React.useCallback(() => {
        onPress(form, department, item);
        statusStore.setHintMessage("", "", undefined, undefined);
    }, [item.id]);

    const handleStepHint = React.useCallback((val: string) => {
        const userStep = val || "N/D";
        statusStore.setHintMessage("Asignado a ", userStep.split("|").pop());
    }, []);
    
    const taskId = fromTaskId;
    return (
        <View style={styles.itemContainer} onLayout={onLayout}>
            <View style={styles.innerRow}>
                {getIconItem(item.status, item.statusWarning ? "warning.400" : undefined)}
                <View style={styles.contentWrapper}>
                    <Pressable key={item.id + "onPress"} onPress={handleMainPress} disabled={isSwiping}>
                        <View style={styles.titleRow}>
                            <Text style={styles.itemTitle}>{item.title?.trim() == "" ? (new Date(item._startedAt).getYYYYMMddHHmmss()) : item.title}</Text>
                            {_hasSteps && getIconItemPTW(item.statusPTW)}
                        </View>
                        {_hasSteps ? 
                        <View style={styles.subInfoRow}>
                            <Text style={styles.subText}>
                                {form.name} {item.stepNumber + 1}/{form.workflow.steps.length + 1}
                            </Text>
                            {item.statusPTW !== "closed" ? (
                                <WorkflowSteps
                                    steps={form.workflow}
                                    currentStep={stepNumber}
                                    currentStateOnly={currentStateOnly}
                                    itemPayload={item.payload}
                                    onStepPress={handleStepHint}
                                />
                            ) : <></>}

                        </View>
                        :<></>}
                    </Pressable>
                </View>
                {item.taskId && taskId == undefined ?
                    <Button width={55} height={55} borderRadius={0} borderWidth={0} p="$1" bgColor={"$white"}
                        variant="outline"
                        key="itemsStore-removeItemsDialog"
                        onPress={() => { navigation.navigate("TaskDetails", { taskId: item.taskId, fromTaskList: false }) }}
                    >
                        <ButtonIcon as={MaterialIcons} name="event" fontWeight="$extrabold" size="xl" color="$secondary400" />
                    </Button>
                    :
                    <></>
                }
                {item.taskId && taskId == undefined ?
                    <Button width={45} height={45} borderRadius={0} borderWidth={0} p="$1" bgColor={"$white"}
                        variant="outline"
                        key="itemsStore-removeItemsDialog"
                        onPress={() => { navigation.navigate("TaskDetails", { taskId: item.taskId, fromTaskList: false }) }}
                    >
                        <ButtonIcon as={MaterialIcons} name="event" fontWeight="$extrabold" size="xl" color="$secondary400" />
                    </Button>
                    :
                    <></>
                }
                {showCheck ? (
                    <Pressable onPress={() => { console.log("selectITEM IN"); selectItem(item) }} ><Box height={35} width={45} alignItems="center" justifyContent="center">
                        {itemsSelected?.includes(item)? <Icon mx="5" size="lg" name="checkbox-outline" as={Ionicons} /> : <Icon mx="2" size="lg" name="square-outline" as={Ionicons} />}
                    </Box>
                    </Pressable>
                ) : (
                    <Pressable onPress={handleMainPress}>
                        <Icon name="arrow-forward" as={Ionicons} size="md" color="light.400" />
                    </Pressable>
                )}
            </View>
            {Platform.OS == "web" && (
                <View style={styles.innerRowBottom}>
                    <Icon size="12px" color="$light800" name="dots-three-horizontal" as={Entypo} />
                </View>
            )}
        </View>
    );
}, (prev, next) => {
    // Solo re-renderizar si cambian propiedades críticas
    return (
        prev.item.status === next.item.status &&
        prev.item.id === next.item.id &&
        prev.item.statusPTW === next.item.statusPTW &&
        prev.item.statusWarning === next.item.statusWarning &&
        prev.item.stepNumber === next.item.stepNumber &&
        prev.item.title === next.item.title &&
        prev.isSwiping === next.isSwiping &&
        prev.showCheck === next.showCheck && 
        prev.itemsSelected?.includes(prev.item) === next.itemsSelected?.includes(next.item)
    );
});
ItemRow.displayName = "ItemRow";

export const HiddenActions = React.memo(({ item, form, department, onClone, onPDF, onRemove }: any) => {
  return (
    <View style={styles.hiddenActionWrapper}>
      <View style={styles.actionGroup}>
        <Pressable
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.violet500 }]} // violet500
          onPress={() => onClone(form, department, item)}
        >
          <Ionicons name="copy" size={22} color="#FFF" />
        </Pressable>

        <Pressable
          disabled={item.status !== "sent" && item.id === undefined}
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.success500 }]} // success500
          onPress={() => onPDF(item)}
        >
          <FontAwesome5 name="file-pdf" size={20} color="#FFF" />
        </Pressable>

        <Pressable
          disabled={item.status !== "sent" && item.id === undefined}
          style={[styles.actionButton, { backgroundColor: glueStyles.colors.yellow500 }]} // yellow500
          onPress={() => onPDF(item, true)}
        >
          <Ionicons name="mail" size={22} color="#FFF" />
        </Pressable>
      </View>

      <Spacer />

      <Pressable
        style={[styles.actionButton, { backgroundColor: glueStyles.colors.danger500 }]} // danger500
        onPress={() => onRemove(department, form, item)}
      >
        <Ionicons name="trash-outline" size={22} color="#FFF" />
      </Pressable>
    </View>
  );
});
HiddenActions.displayName = "HiddenActions";


const styles = StyleSheet.create({
  itemContainer: {
    backgroundColor: glueStyles.colors.white,
    borderBottomColor: glueStyles.colors.light300,
    borderBottomWidth: 1,
    justify: "center",
    minHeight: 70,
    width: "100%",
  },
  innerRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  innerRowBottom: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4

  },
  contentWrapper: {
    flex: 1,
    marginHorizontal: 10,
    justifyContent: "center",
  },
  titleRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 2,
  },
  itemTitle: {
    fontSize: glueStyles.fontSizes.md,
    fontWeight: glueStyles.fontWeights.medium,
    color: glueStyles.colors.light700,
    marginRight: 6,
    flexShrink: 1,
  },
  subInfoRow: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  subText: {
    fontSize: 12,
    color: glueStyles.colors.light500,
    marginRight: 4,
  },
  hiddenActionWrapper: {
    alignItems: "center",
    backgroundColor: glueStyles.colors.light100,
    flexDirection: "row",
    flex: 1,
    marginHorizontal: 2,
  },
  actionGroup: {
    flexDirection: "row",
    height: "100%",
  },
  actionButton: {
    width: 55,
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
});